import React, { memo, useEffect } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import Image from '../Image/Image';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { SearchBox, useSearchBox } from 'react-instantsearch-hooks-web';
import { DeleteQueryParam } from '../../utils/DeleteQueryParam/DeleteQueryParam.util';
import { SetQueryParam } from '../../utils/SetQueryParam/SetQueryParam';
import SbImage from '../SbImage/SbImage';
import { searchTimeoutQueryHook } from '../../utils/searchTimeoutQueryHook/searchTimeoutQueryHook.util';

interface SearchResultsHeroProps {
  hero_background_image: StoryblokAsset;
  hero_heading: string;
  hero_body?: JSX.Element;
  hero_search_bar_placeholder: string;
}

const SearchResultsHero: React.FC<SearchResultsHeroProps> = ({
  hero_background_image,
  hero_heading,
  hero_body = undefined,
  hero_search_bar_placeholder,
}) => {
  const { query } = useSearchBox();

  useEffect(() => {
    DeleteQueryParam('page');
    query === '' ? DeleteQueryParam('q') : SetQueryParam('q', query);
  }, [query]);

  return (
    <section className="relative">
      {hero_background_image?.filename && (
        <div className="absolute top-0 right-0 bottom-0 left-0 overflow-hidden">
          <SbImage
            asset={hero_background_image}
            options={{
              objectFit: 'cover',
              sizes: {
                base: 640,
                sm: 768,
                md: 1024,
                lg: 1280,
                xl: 1536,
                xxl: 1920,
              },
              loading: 'eager',
            }}
          />
        </div>
      )}
      <div className="relative h-[356px] bg-[#0B212E]/80 flex items-center justify-center md:h-[382px] lg:h-[438px] xl:h-[492px]">
        <Container>
          <Grid>
            <Col
              span={{ md: 10, lg: 8, xl: 6 }}
              start={{ md: 2, lg: 3, xl: 4 }}
            >
              <div className="w-full h-full flex items-center justify-center">
                <div className="w-full space-y-12">
                  <div className="space-y-8 text-center">
                    <Heading
                      text={hero_heading}
                      headingType={HeadingTypes.h1}
                    />
                    {/*-- dynamically injected jsx element --*/}
                    {hero_body && hero_body}
                  </div>
                  <SearchBox
                    placeholder={hero_search_bar_placeholder}
                    classNames={{
                      root: 'w-full',
                      form: 'w-full',
                      input:
                        'w-full h-16 p-5 rounded-lg text-system/black focus:outline-none',
                      submit: 'hidden',
                      submitIcon: 'hidden',
                      reset: 'hidden hover:hidden',
                      resetIcon: 'hidden hover:hidden',
                    }}
                    queryHook={searchTimeoutQueryHook}
                  />
                </div>
              </div>
            </Col>
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(SearchResultsHero, Theme.DARK));
